import { Outlet } from "react-router-dom";
import { AreaNavigationBar } from "../components/AreaNavigationBar";
import { useHandleCountyUrlChanges } from "../hooks/useHandleCountyUrlChanges";

export const AreasLayout: React.FC = () => {
  useHandleCountyUrlChanges();

  return (
    <>
      <AreaNavigationBar />
      <Outlet />
    </>
  );
};
